import React from 'react';
import { Field } from 'react-form';
import PropTypes, { any } from 'prop-types';

import InfoButton from '../../InfoButton';
import useModerateText from '../useModerateText';

import styles from './TextArea.scss';

const Textarea = (props) => {
    const { validateSync, validateAsync } = useModerateText({
        validateFn: props.validate,
        asyncValidateFn: props.asyncValidate,
        disableProfanityCheck: props.disableProfanityCheck,
    });

    return (
        <Field field={props.field} validate={validateSync} asyncValidate={(value) => validateAsync(value, props.submitting)}>

            { fieldApi => {
                const { onChange, onBlur, field, validate, id, label, hiddenLabel, description, hoverText, defaultValue, themeV3, asyncErrors, ...rest } = props;
                const { value, error, warning, touched, setValue, setTouched } = fieldApi;

                const displayError = error || (asyncErrors && (asyncErrors.answer || asyncErrors?.[field]));

                const inputProps = {
                    ...rest,
                    id,
                    className: `form-control ${styles.formControl}`,
                    value: value || defaultValue || '',
                    onChange: e => {
                        setValue(e.target.value);
                        if (onChange) {
                            onChange(e.target.value, e);
                        }
                    },
                    onBlur: e => {
                        // Try to warm the cache so we don't need to delay submission
                        validateAsync(e.target.value, props.submitting !== null);
                        setTouched();
                        if (onBlur) {
                            onBlur(e);
                        }
                    },
                };

                return (
                    <div className={`form-group form-group-xl ${styles.formInput} ${themeV3 ? styles.themeV3 : ''} ${(touched && displayError) && 'is-invalid'}  ${description && 'description'} mb0`}>
                        {!props.themeV3 && props.label && (
                            <label htmlFor={id} className={hiddenLabel ? 'sr-only' : ''}>
                                {label}
                                {hoverText && <InfoButton hoverText={hoverText} />}
                            </label>
                        )}
                        {description && (<small>{description}</small>)}
                        <div className="input-wrapper">
                            <textarea {...inputProps} />
                            {!themeV3 && <div className="error-indicator" />}
                            {props.themeV3 && props.label && (
                                <label>{props.label}</label>
                            )}
                            <div className="error-indicator" />
                        </div>
                        {touched &&
                            ((displayError && <div className="invalid-feedback">{displayError}</div>) ||
                            (warning && <div className="warning-feedback">{warning}</div>))}
                    </div>
                );
            }}
        </Field>
    );
};

Textarea.propTypes = {
    themeV3: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    field: PropTypes.string,
    validate: PropTypes.func,
    asyncValidate: PropTypes.func,
    asyncErrors: PropTypes.objectOf(any),
    submitting: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.string,
    hiddenLabel: PropTypes.bool,
    description: PropTypes.string,
    hoverText: PropTypes.string,
    defaultValue: PropTypes.string,
    disableProfanityCheck: PropTypes.bool,
};

Textarea.defaultProps = {
    validate: () => { },
    asyncValidate: () => { },
    onChange: () => { },
    onBlur: () => { },
    themeV3: false,
    field: '',
    id: '',
    label: '',
    hiddenLabel: false,
    description: '',
    hoverText: '',
    defaultValue: '',
    disableProfanityCheck: false,
    asyncErrors: {},
    submitting: null,
};

export default Textarea;
